// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-2iHVW";
var _4 = "list-2rzgX";
var _5 = "item-1VpGY";
var _6 = "item_gone-BrfOb";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "list", _5 as "item", _6 as "item_gone" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "list": _4, "item": _5, "item_gone": _6 }
